var exports = {
  "kL": "x31de4314--dc05a5--container",
  "HU": "x31de4314--dc05a5--aside",
  "T1": "x31de4314--dc05a5--call",
};

module.exports = exports;
